<template>
  <div class="item-name">
    <template v-if="sub">
      <div v-if="item.name_parts.is_stattrak" class="item-category stattrak" :class="{ 'star' : is_star }">
        {{ is_star || `${$t('market.stattrak')} ${item_parts?.type}` }}
      </div>
      <div v-else-if="item.name_parts.is_souvenir" class="item-category souvenir">
        {{ $t('market.souvenir') }} {{ item_parts?.type }}
      </div>
      <div v-else class="item-category" :class="{ 'star' : is_star }">
        {{ item_type }}
      </div>
    </template>
    <div class="value">
      <span>
        {{ item_name || item.name }}
        {{ item_fade }}
      </span>
      <img
        v-if="item.nametag"
        v-tooltip="{
          title: $t('market.nametag'),
          position: 'center top',
          message: item_nametag,
          class: ['text-center'],
        }"
        src="@/asset/icon/nametag.svg"
        alt="nametag"
      >
    </div>
    <ItemDetails
      v-if="item.quality || item.exterior || item.hero || item.type"
      :item="item"
      :exterior="item.exterior || item.name_parts.quality"
      :quality="item.quality"
      :hero="item.hero"
      :type="item.type"
      :paint_seed="item.paint_seed"
    />
  </div>
</template>

<script setup>
import { copyName } from '@/hook/market/items.js';
import { computed } from 'vue';
import { PhaseEnum } from '@/helper/steam.js';
import ItemDetails from '@/component/item/ItemDetails.vue';

const props = defineProps({
  item: {
    type: Object,
    required: true,
  },
  sub: {
    type: Boolean,
  },
  copy: {
    type: Boolean,
  },
});

const item_parts = computed(() => props.item.name_parts || {});
const is_star = computed(() => {
  if (props.item?.star) {
    const trim_name = item_parts.value.type
      ? item_parts.value.type.split(' ')
      : item_parts.value.subname.split(' ');
    trim_name.shift();

    if (props.item.category) {
      return `${props.item.category} ${trim_name.join(' ').trim()}`;
    }
    return `★ StatTrak™ ${trim_name.join(' ').trim()}`;
  }
  return null;
});

const item_type = computed(() => {
  if (props.item?.star && !item_parts.value?.type) {
    return item_parts.value?.subname;
  }

  return item_parts.value?.type || '';
});

const item_name = computed(() => {
  if (props.item?.star && !item_parts.value?.type) {
    return 'Vanilla';
  }
  return item_parts.value?.subname || '';
});

const sub = computed(() => props.sub && props.item.name_parts);

const item_fade = computed(() => {
  if (props.item?.extras_1 && props.item?.phase_id === PhaseEnum.fade) {
    return `(${(props.item.extras_1 / 100_000_0).toFixed(0)}%)`;
  }
  return null;
});

const item_nametag = computed(() => `"${props.item.nametag}"`);
</script>
